module.exports = __webpack_public_path__ + "img/block3.e699082f.png";